<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="page-header-container">
        <h2>{{ 'common.testimonials' | translate }}</h2>
        <div class="header-accent-line"></div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-12">
      <div class="testimonials-wrapper">
        
        <p *ngIf="loading else testimonialsList" class="text-center py-4">
          <label class="text-muted"><i class="fa fa-spinner fa-spin mr-2"></i>{{ 'common.loading' | translate }} ...</label>
        </p>

        <ng-template #testimonialsList>
          <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div *ngFor="let e of testimonials" class="col mb-4">
              
              <div class="testimonial-card">
                <div class="card-quote-icon">“</div>
                
                <div class="card-text-content">
                  <p class="testimonial-comment">
                    "{{ e.comment }}"
                  </p>
                </div>
                
                <div class="card-author-profile">
                  <div class="testimonial-photo">
                    <img *ngIf="e.photo" [src]="e.photo" [alt]="e.author" />
                    <div *ngIf="!e.photo" class="photo-placeholder">
                      <i class="fa fa-user"></i>
                    </div>
                  </div>
                  
                  <h5 class="testimonial-author">{{ e.author }}</h5>
                  
                  <span class="testimonial-role">
                    {{ e.role ? (e.role.startsWith('undefined') ? e.role.replace('undefined,', '').trim() : e.role) : '' }}
                  </span>
                  
                  <div *ngIf="e.location" class="testimonial-location">
                    <i class="fa fa-map-marker-alt"></i> {{ e.location }}
                  </div>
                </div>
                
              </div>
              
            </div>
          </div>

          <div *ngIf="testimonials.length === 0" class="text-center py-5">
            <p class="lead text-muted">{{ 'common.no_testimonials' | translate }}</p>
          </div>
        </ng-template>
        
      </div>
    </div>
  </div>
</div>